import React, { useState } from "react";
import Select from "react-select";
import "./css/projectcategory.css";

const ProjectSpecializationSelector = ({
  setSelectedOption,
  optionData,
  selectedData,
  isLoading = false,
}) => {
  const [specMenuOpen, setSpecMenuOpen] = useState(false);

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      cursor: "text",
    }),
    input: (provided) => ({
      ...provided,
      cursor: "text",
    }),
    loadingIndicator: (provided) => ({
      ...provided,
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      position: "absolute",
      top: "100%",
      left: 0,
      width: "100%",
      zIndex: 10,
    }),
    // menuPortal: (base) => ({
    //   ...base,
    //   zIndex: 9999,
    // }),
  };

  return (
    <div className="job-select-container">
      <Select
        options={optionData || []}
        onChange={handleChange}
        value={selectedData}
        classNamePrefix="react-select"
        placeholder="Choose specialization"
        onFocus={() => setSpecMenuOpen(true)}
        onBlur={() => setSpecMenuOpen(false)}
        menuIsOpen={specMenuOpen}
        isLoading={isLoading}
        loadingMessage={() => "Loading specializations..."}
        noOptionsMessage={() => {
          if (isLoading) {
            return "Loading specializations...";
          }
          if (!optionData || optionData.length === 0) {
            return "First select a category";
          }
          return "No specializations found";
        }}
        onMenuClose={() => setSpecMenuOpen(false)}
        onMenuOpen={() => setSpecMenuOpen(true)}
        styles={customStyles}
        menuPosition="absolute"
        menuPlacement="bottom"
        closeMenuOnScroll={false}
        menuShouldScrollIntoView={false} 
      />
    </div>
  );
};

export default ProjectSpecializationSelector;
